var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80078 6.00005C1.80078 5.33731 2.33804 4.80005 3.00078 4.80005H21.0008C21.6635 4.80005 22.2008 5.33731 22.2008 6.00005C22.2008 6.66279 21.6635 7.20005 21.0008 7.20005H3.00078C2.33804 7.20005 1.80078 6.66279 1.80078 6.00005ZM1.80078 12C1.80078 11.3373 2.33804 10.8 3.00078 10.8H21.0008C21.6635 10.8 22.2008 11.3373 22.2008 12C22.2008 12.6628 21.6635 13.2 21.0008 13.2H3.00078C2.33804 13.2 1.80078 12.6628 1.80078 12ZM3.00078 16.8C2.33804 16.8 1.80078 17.3373 1.80078 18.0001C1.80078 18.6628 2.33804 19.2001 3.00078 19.2001H21.0008C21.6635 19.2001 22.2008 18.6628 22.2008 18.0001C22.2008 17.3373 21.6635 16.8 21.0008 16.8H3.00078Z",
    fill: "#002D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.d4930e0bea2c65ed844ffe1eae07076d.svg";
export { ForwardRef as ReactComponent };